import { render, staticRenderFns } from "./tiktok.vue?vue&type=template&id=d2a60b8c&scoped=true&"
import script from "./tiktok.vue?vue&type=script&lang=tsx&"
export * from "./tiktok.vue?vue&type=script&lang=tsx&"
import style0 from "./tiktok.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tiktok.vue?vue&type=style&index=1&id=d2a60b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a60b8c",
  null
  
)

export default component.exports